export const PUBLIC_ICP_FILING = "沪ICP备2026040916号";
export const PUBLIC_ICP_FILING_URL = "https://beian.miit.gov.cn/";

export function PublicIcpLink(): React.JSX.Element {
  return <a href={PUBLIC_ICP_FILING_URL} target="_blank" rel="noopener noreferrer">{PUBLIC_ICP_FILING}</a>;
}

export function PublicFooterLegalLinks(): React.JSX.Element {
  return <>
    <a href="#/privacy">隐私政策</a>
    <span aria-hidden="true"> · </span>
    <a href="mailto:yunchenlab@yeah.net">yunchenlab@yeah.net</a>
    <span aria-hidden="true"> · </span>
    <PublicIcpLink />
  </>;
}
